import { t, useLanguage } from "@/lib/i18n";
import React from "react";
import "@/App.css";
import { createBrowserRouter, RouterProvider, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import PageMetadata from "@/components/PageMetadata";
import NotFound from "@/pages/NotFound";
import About from "@/pages/About";
import FeedbackInbox from "@/pages/FeedbackInbox";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ChangePassword from "@/pages/ChangePassword";
import PasswordReset from "@/pages/PasswordReset";
import AccountSettings from "@/pages/AccountSettings";
import TreeApp from "@/pages/TreeApp";
import Admin from "@/pages/Admin";
import TreeBuilder from "@/pages/TreeBuilder";
import Albums from "@/pages/Albums";
import Subscriptions from "@/pages/PlansPage";
import MemberRequests from "@/pages/MemberRequests";
import SiteViewTracker from "@/components/SiteViewTracker";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import NotificationBell from "@/components/NotificationBell";
import HeaderAccount from "@/components/HeaderAccount";

const ProtectedRoute = ({ children }) => {
  useLanguage();
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
        <div className="font-serif text-2xl text-stone-500 animate-pulse">{t("Loading your lineage…")}</div>
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ returnTo: location.pathname + location.search }} replace />;
  if (user.role !== "guest" && !user.email_verified) return <Navigate to="/verify-email" replace />;
  return children;
};

function AppContent() {
  useLanguage();
  const { pathname } = useLocation();
  const pageHasAccountControl = ["/", "/hi", "/hi/", "/app"].includes(pathname);
  return (
    <div className="App">

        <LanguageSwitcher>{!pageHasAccountControl && <HeaderAccount />}<NotificationBell /></LanguageSwitcher>
        <PageMetadata />
        <SiteViewTracker />
        <Routes>
          <Route path="/tree-builder" element={<ProtectedRoute><TreeBuilder /></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/" element={<Landing />} />
          <Route path="/hi" element={<Landing />} />
          <Route path="/hi/about" element={<About />} />
          <Route path="/hi/contact" element={<Contact />} />
          <Route path="/hi/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/submissions" element={<ProtectedRoute><FeedbackInbox /></ProtectedRoute>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/requests" element={<ProtectedRoute><MemberRequests /></ProtectedRoute>} />
          <Route path="/albums" element={<ProtectedRoute><Albums /></ProtectedRoute>} />
          <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <TreeApp />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>

    </div>
  );
}

const router = createBrowserRouter([{ path: "*", element: <AppContent /> }]);
export default function App() { return <RouterProvider router={router} />; }
